// extracted by mini-css-extract-plugin
module.exports = {"eyebrow":"eyebrow___30mk8","large":"large___13sYc","typeIcon":"typeIcon___YPtQF"};